import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=6f0c1073&scoped=true"
import script from "./OrderStatistics.vue?vue&type=script&lang=js"
export * from "./OrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./OrderStatistics.vue?vue&type=style&index=0&id=6f0c1073&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c1073",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0c1073')) {
      api.createRecord('6f0c1073', component.options)
    } else {
      api.reload('6f0c1073', component.options)
    }
    module.hot.accept("./OrderStatistics.vue?vue&type=template&id=6f0c1073&scoped=true", function () {
      api.rerender('6f0c1073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderStatistics/OrderStatistics.vue"
export default component.exports